export default __webpack_public_path__ + "static/media/logout_active.e4f76a00.svg";